import "./bootstrap";

import {
    Livewire,
    Alpine,
} from "../../vendor/livewire/livewire/dist/livewire.esm";

// import { clipboard, no_clipboard } from "./alpinedirectives";
// import { encrypt } from "./alpinedirectives";
import { external_link, regexp_check } from "./alpinedirectives";
import { regexp } from "./livewire_regexp";
import livewire_encrypt from "./livewire_encrypt";
import livewire_noclipboard from "./livewire_noclipboard";

import mask from "@alpinejs/mask";

// Alpine.directive("clipboard", clipboard);
// Alpine.directive("encrypt", encrypt);
Alpine.directive("external-link", external_link);
// Alpine.directive("no-clipboard", no_clipboard);
// Alpine.directive("regexp-check", regexp_check);

Alpine.plugin(mask);

Livewire.directive("regexp", regexp);
Livewire.directive("encrypt", livewire_encrypt);
Livewire.directive("no-clipboard", livewire_noclipboard);

Livewire.start();
